import { useState } from "react";

import { Box } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Popover from "@mui/material/Popover";
import { alpha } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { IoMdArrowDropdown } from "react-icons/io";
import { CiLogout } from "react-icons/ci";

// ----------------------------------------------------------------------
const account = {
  displayName: "Jaydon Frankie",
  email: "demo@minimals.cc",
  //photoURL: "/assets/images/avatars/avatar_25.jpg",
};

const MENU_OPTIONS = [
//   {
//     label: "Editar perfil",
//     icon: "eva:home-fill",
//     link: "/home/editar-perfil",
//   },
];

// ----------------------------------------------------------------------

export default function AccountPopover({ handleClose, open, anchorEl, handleLogout }) {

	const user = useSelector((state) => state.auth.user);

    return (
        <>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                    sx: {
                        p: 0,
                        mt: 3,
                        ml: 0,
                        width: 250,
                        borderRadius: '10px', // Aumenta el radio de las esquinas
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Sombra para más profundidad
                        backgroundColor: '#ffffff', // Fondo blanco para el popover
                    },
                }}
            >

                <Box sx={{ py: 2, px: 3 }} className="">
                    <Typography  fontWeight={500} color={"black"}  variant="subtitle2" noWrap>
                        {user && user.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
                        {user && user.email}
                    </Typography>
                </Box>

                {/* <Divider sx={{ borderStyle: "dashed" }} /> */}

                {/* {MENU_OPTIONS.map((option) => (
                    <MenuItem key={option.label} onClick={handleClose}>
                        <Link className="w-full" to={option.link}>
                            <div className="w-full text-sm"> {option.label}</div>
                        </Link>
                    </MenuItem>
                ))} */}

                <Divider sx={{ borderStyle: "solid", m: 0 }} />

                <MenuItem
                    disableRipple
                    disableTouchRipple  
                    onClick={handleLogout}
                    type="button"
                    sx={{ 
                        color: "green", 
                        pr: 4,
                        transition: "all 0.2s",
                        "&:hover": {
                            backgroundColor: "#F2F8ED",
                        }
                    }}
                >   
                    <div className="flex flex-row items-center justify-center gap-4 w-full">
                        <CiLogout />
                        Salir
                    </div>
                </MenuItem>
            </Popover>
        </>
    );
}
